export enum TimelineApproach {
  FIXED = 'FIXED',
  FLEXIBLE = 'FLEXIBLE',
}
